var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M56 50h-5.861a1 1 0 0 1 0-2H56a2.003 2.003 0 0 0 2-2V14a2.003 2.003 0 0 0-2-2H8a2.003 2.003 0 0 0-2 2v32a2.003 2.003 0 0 0 2 2h5.861a1 1 0 0 1 0 2H8a4.004 4.004 0 0 1-4-4V14a4.004 4.004 0 0 1 4-4h48a4.004 4.004 0 0 1 4 4v32a4.004 4.004 0 0 1-4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M59 20H5a1 1 0 0 1 0-2h54a1 1 0 0 1 0 2M55 16.5a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3.001m0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M51 16.5a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3.001m0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M47 16.5a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3.001m0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M44.997 54H19.003a3 3 0 0 1-2.584-4.523l12.996-22.001A2.98 2.98 0 0 1 32 26a2.97 2.97 0 0 1 2.584 1.477L47.58 49.476A3.001 3.001 0 0 1 44.997 54M32 28a.99.99 0 0 0-.863.492v.001l-12.996 22A.999.999 0 0 0 19.003 52h25.994a1 1 0 0 0 .861-1.508L32.861 28.493A.98.98 0 0 0 32 28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M32 44a1 1 0 0 1-.99-.858l-1-7A1 1 0 0 1 30 36a2 2 0 0 1 4 0 1 1 0 0 1-.01.142l-1 7A1 1 0 0 1 32 44M32 50a2 2 0 1 1 0-4.001A2 2 0 0 1 32 50"
  })));
};
export default SvgIconWarning;